import React from "react";
import { useAtom, useAtomValue } from "jotai";
import {
    filterAndSortMarkList,
    getStudentListAtom,
    questionnaireIdAtom,
    statusFilterAtom,
    exerciseInfoAtom
} from "../../../../../service/stores/Question/Students";
import style from "../index.module.scss";
import DetailLayout from "../../../components/DetailLayout";
import CourseHeader from "../../../components/CourseHeader";
import Buttons from "../components/Buttons";
import StudentsTable from "../components/StudentsTable";
import BriefInfo from "../../Components/BriefInfo";

const Index = () => {
    const questionnaireId = useAtomValue(questionnaireIdAtom);
    const [filter, setFilter] = useAtom(statusFilterAtom);
    const data = useAtomValue(getStudentListAtom);

    // 筛选数据
    const markList = useAtomValue(filterAndSortMarkList);
    const exerciseInfo = useAtomValue(exerciseInfoAtom);

    return (
        <DetailLayout breadcrumb="问卷详情">
            {data && (
                <CourseHeader
                    title={data.questionnaire.description}
                    info={<BriefInfo {...exerciseInfo} />}
                    extra={
                        <span className={style.percent}>
                            参与率{data.joinPercent}
                        </span>
                    }
                />
            )}

            {data && (
                <Buttons
                    status={filter}
                    onChange={setFilter}
                    noJoinCount={data.unJoinNo}
                    joinCount={data.joinNo}
                    allCount={data.studentNo}
                    questionnaireId={questionnaireId}
                />
            )}

            <StudentsTable data={markList} questionnaireId={questionnaireId} />
        </DetailLayout>
    );
};

export default Index;
